import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import { getListNguonVon, updateDataSearch } from "../../../actions/NguonVon";
import { currentDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import { pushNotification } from "utils/notifications";
import { ThongTinNguoiGopVon } from "./ThongTinNguoiGopVon";
import { GiaoDich } from "./GiaoDich";
import userApi from "../../../service/userApi";
import NguonVonApi from "../../../service/nguonVonApi";
import { SuaLichSuGiaoDich } from "./SuaLichSuGiaoDich";
export const ModalThemMoi = (props) => {
  const dataSearch = useSelector((state) => state.dataSearchNguonVon);
  const dispatch = useDispatch();
  const [isSubbmit, setIsSubmit] = useState(false);
  const initData = {
    customerId: props.customerId,
    ten: "",
    ngaysinh: "",
    diachi: "",
    dienthoai: "",
    cmnd: "",
    ngaycap: "",
    noicap: "",
    ngaygiaodich: currentDate(),
    nhanvien: "",
    sotiengop: 0,
    ghichu: "",
  };
  const [dataNguonVon, setDataNguonVon] = useState(initData);

  const updateDropdown = (field) => (e) => {
    setDataNguonVon({
      ...dataNguonVon,
      [field]: e.target.value,
    });
    if (e.target.value === "" || e.target.value === "0") {
      setErrors1({
        ...errors1,
        nhanvien: "Chọn nhân viên giao dịch",
      });
    } else {
      setErrors1({
        ...errors1,
        nhanvien: "",
      });
    }
  };

  //Set Data khi Update trường dữ liệu
  const updateTextValue = (field) => (e) => {
    setDataNguonVon({
      ...dataNguonVon,
      [field]: e.target.value,
    });
    if (e.target.value === "") {
      setErrors({
        ...errors,
        ten: "Nhập họ tên khách hàng",
      });
      setErrors3({
        ...errors3,
        ghichu: "Vui lòng nhập ghi chú",
      });
    } else {
      setErrors({
        ...errors,
        ten: "",
      });
      setErrors3({
        ...errors3,
        ghichu: "",
      });
    }
  };
  const onChangeNumber = (field) => (evt) => {
    setDataNguonVon({
      ...dataNguonVon,
      [field]: convertToNumber(evt.target.value),
    });
    if (evt.target.value === "") {
      setErrors2({
        ...errors2,
        sotiengop: "Vui lòng Nhập số tiền",
      });
    } else if (evt.target.value === 0) {
      setErrors2({
        ...errors2,
        sotiengop: "Vui lòng Nhập số tiền",
      });
    } else {
      setErrors2({
        ...errors2,
        sotiengop: "",
      });
    }
  };

  const onChangeDate = (field) => (evt) => {
    setDataNguonVon({
      ...dataNguonVon,
      [field]: formatDayMonth(evt),
    });
  };

  const dataOption = {
    nguoiTaoOption: [
      {
        label: "Nguyễn Thị Thu Hằng",
        value: "Nguyễn Thị Thu Hằng",
      },
      {
        label: "Trần Văn B",
        value: "Trần Văn B",
        selected: true,
      },
    ],
  };

  const [listUser, setListUser] = useState(dataOption.nguoiTaoOption);
  useEffect(() => {
    if (props.customerId > 0) {
      NguonVonApi.chiTietNguonVon(props.customerId).then((response) => {
        setDataNguonVon({
          ...dataNguonVon,
          ten: response.data.Ten,
          ngaysinh: response.data.NgaySinh,
          diachi: response.data.DiaChi,
          dienthoai: response.data.SoDienThoai,
          cmnd: response.data.CMND,
          ngaycap: response.data.NgayCap,
          noicap: response.data.NoiCap,
        });
      });
    }

    userApi.combo().then((response) => {
      const dataComboUser = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setListUser(dataComboUser);
    });
  }, []);

  //Thông báo
  const validateName = (nguoinop) => {
    const expression = /(\w.).+/i;
    return expression.test(String(nguoinop).toLowerCase());
  };

  const initErrors = {
    ten: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const initErrors1 = {
    nhanvien: "",
  };
  const [errors1, setErrors1] = useState(initErrors1);
  const initErrors2 = {
    sotiengop: "",
  };
  const [errors2, setErrors2] = useState(initErrors2);
  const initErrors3 = {
    ghichu: "",
  };
  const [errors3, setErrors3] = useState(initErrors3);

  const onSubmit = () => {
    if (dataNguonVon.ten === "") {
      setErrors({
        ...errors,
        ten: "Nhập họ tên cổ đông",
      });
      return;
    } else if (!validateName(dataNguonVon.ten)) {
      setErrors({
        ...errors,
        ten: "Tên cổ đông phải có ít nhất 2 từ",
      });
      return;
    }
    if (props.customerId == 0 || props.customerId == undefined) {
      if (
        dataNguonVon.nhanvien === listUser[0].value ||
        dataNguonVon.nhanvien === ""
      ) {
        setErrors1({
          ...errors1,
          nhanvien: "Chọn nhân viên giao dịch",
        });
        return;
      }
      if (dataNguonVon.sotiengop === 0 || dataNguonVon.sotiengop === "") {
        setErrors2({
          ...errors2,
          sotiengop: "Vui lòng Nhập số tiền",
        });
        return;
      }
      if (dataNguonVon.ghichu === "") {
        setErrors3({
          ...errors3,
          ghichu: "Vui lòng nhập ghi chú",
        });
        return;
      }
    }

    setIsSubmit(true);
    if (props.customerId > 0) {
      NguonVonApi.editNguonVon(
        dataNguonVon.customerId,
        dataNguonVon.ten,
        dataNguonVon.ngaysinh,
        dataNguonVon.diachi,
        dataNguonVon.dienthoai,
        dataNguonVon.cmnd,
        dataNguonVon.ngaycap,
        dataNguonVon.noicap,
        dataNguonVon.ngaygiaodich,
        dataNguonVon.nhanvien,
        dataNguonVon.sotiengop,
        dataNguonVon.ghichu
      ).then((response) => {
        setIsSubmit(false);
        if (response.data.Error === 1) {
          pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
          return;
        } else {
          // showAlert();
          pushNotification(
            "Cập nhật thành công.",
            "success",
            "TOP_CENTER",
            1000
          );
          props.onHide();
          dispatch(getListNguonVon(dataSearch));
        }
      });
    } else {
      NguonVonApi.addNguonVon(
        dataNguonVon.ten,
        dataNguonVon.ngaysinh,
        dataNguonVon.diachi,
        dataNguonVon.dienthoai,
        dataNguonVon.cmnd,
        dataNguonVon.ngaycap,
        dataNguonVon.noicap,
        dataNguonVon.ngaygiaodich,
        dataNguonVon.nhanvien,
        dataNguonVon.sotiengop,
        dataNguonVon.ghichu
      ).then((response) => {
        setIsSubmit(false);
        if (response.data.Error === 1) {
          pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
          return;
        } else {
          // showAlert();
          pushNotification(
            "Thêm mới thành công",
            "success",
            "TOP_CENTER",
            1000
          );
          props.onHide();
          dispatch(getListNguonVon(dataSearch));
        }
      });
    }
  };
  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
          </span>{" "}
          {props.customerId > 0 ? "Sửa" : "Thêm mới"} cổ đông
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal form-edit">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div className="card-header">
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Thông tin người góp vốn</h3>
                </a>
              </div>
              <ThongTinNguoiGopVon
                dataNguonVon={dataNguonVon}
                onChangeDate={onChangeDate}
                updateTextValue={updateTextValue}
                onChangeNumber={onChangeNumber}
                errors={errors}
              />

              {props.customerId > 0 ? (
                <SuaLichSuGiaoDich customerId={props.customerId} />
              ) : (
                <GiaoDich
                  dataNguonVon={dataNguonVon}
                  onChangeDate={onChangeDate}
                  updateTextValue={updateTextValue}
                  onChangeNumber={onChangeNumber}
                  listUser={listUser}
                  updateDropdown={updateDropdown}
                  errors1={errors1}
                  errors2={errors2}
                  errors3={errors3}
                />
              )}
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>

        {isSubbmit == false && (
          <>
            <button
              className="btn btn-new-main btn-checknew"
              href={() => false}
              onClick={onSubmit}
            >
              <span>
                <img src="/app-assets/images/icon-save-v2-white.png" />
              </span>
              &nbsp;{props.customerId > 0 ? "Xác nhận" : "Thêm mới"} &nbsp;
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};
